<div class="p-3">
  <ng-container *ngIf="durationSelected !== 'Monthly'; else monthlyView">
    <div
      class="col-lg-12 calender-board"
      [class.weekly-view]="durationSelected === 'Weekly'"
      [class.daily-view]="durationSelected === 'Daily'">
      <div class="arrow-bar">
        <a (click)="paginateLeft()" class="left-arrow">
          <i class="pi pi-angle-left"></i
        ></a>
        <a (click)="paginateRight()" class="left-right">
          <i class="pi pi-angle-right"></i
        ></a>
      </div>

      <div class="Container Flipped">
        <div class="Content">
          <div class="scroll-box week-screen">
            <div
              *ngIf="
                !loaderState &&
                (!activeListing || (activeListing | keyvalue)?.length === 0) &&
                (!overdueTasks || overdueTasks.length === 0)
              "
              class="col-lg-3">
              <h2 class="mb-2" *ngIf="durationSelected === 'Weekly'">
                No due tasks in duration {{ getToDate() | date: "dd, MMM" }} -
                {{ getFromDate() | date: "dd, MMM" }}
              </h2>
              <h2 class="mb-2" *ngIf="durationSelected === 'Daily'">
                No due tasks in {{ getDisplayDate() | date: "dd, MMM" }}
              </h2>
            </div>

            <!-- Overdue Swimlane - Static column for Weekly view only -->
            <div
              *ngIf="durationSelected === 'Weekly'"
              class="col-lg-3 week-col"
              pDroppable
              (onDrop)="onDropToOverdue(dropIndex)"
              [class.drop-target-highlight]="draggedTask && draggedFromOverdue">
              <h2 class="mb-3">Overdue</h2>
              <div class="grid-col p-3 overdue-bg">
                <div
                  class="card-scroll"
                  #scrollOverDueContainer
                  (scroll)="onOverdueScroll($event)">
                  <div
                    class="ticket-card mb-3 draggable-task"
                    *ngFor="let product of overdueTasks; let i = index"
                    pDraggable
                    [pDraggableDisabled]="isTitleEditing(product.taskId)"
                    pDroppable
                    (onDragStart)="onDragStart(product, null, true)"
                    (onDragEnd)="onDragEnd()"
                    (onDragEnter)="onDragOver(i)">
                    <div
                      *ngIf="
                        myTasks ||
                        (!myTasks && !product.isExternal && !product.isAdmin)
                      "
                      [ngClass]="{ 'task-gradiant': product.dueDatePassed }"
                      (dblclick)="redirectToTaskSummary(product.taskId)">
                      <div
                        class="p-3 custom-card shadow-sm card-border Weekly-card"
                        [style.border-left]="
                          'solid 6px ' +
                          (product.dueDatePassed
                            ? '#3a3a3a'
                            : getPriorityColor(
                                product.priorityType,
                                product.taskType
                              ))
                        ">
                        <div class="card-body">
                          <!-- Top Section -->
                          <div
                            class="d-flex justify-content-between align-items-start flex-wrap">
                            <div class="col-6">
                              <div
                                class="top-title text-uppercase text-muted text-truncate"
                                pTooltip="{{ product.clientName }}"
                                tooltipPosition="top">
                                {{
                                  product.projectWorkflowId === null &&
                                  product.customerNameWithNoProject
                                    ? product.customerNameWithNoProject
                                    : product.clientName
                                }}
                              </div>

                              <div
                                class="sub-title text-primary text-truncate cursor-pointer"
                                pTooltip="{{ product.jobName }}"
                                tooltipPosition="top"
                                (click)="
                                  openWorkflowSummary({
                                    salesOrderId: product.salesOrderId,
                                    workflowId: product.projectWorkflowId,
                                  });
                                  $event.stopPropagation()
                                ">
                                {{ product.jobName }}
                              </div>
                            </div>

                            <div class="text-start col-auto card-texttrun50">
                              <div
                                class="text-muted border-start ps-2 ms-2 text-truncate"
                                pTooltip="{{ product.nickName }}"
                                tooltipPosition="top"
                                *ngIf="
                                  product.taskType === TaskTypeEnum.Production
                                ">
                                {{ product.nickName }}
                              </div>
                              <div
                                class="text-muted border-start ps-2 ms-2 text-truncate"
                                pTooltip="{{ product.supplierName }}"
                                tooltipPosition="top"
                                *ngIf="
                                  product.taskType === TaskTypeEnum.Production
                                ">
                                {{ product.supplierName }}
                              </div>
                            </div>
                          </div>

                          <!-- Middle Section -->
                          <div
                            class="d-flex justify-content-between align-items-center mt-2 mb-3 flex-wrap"
                            (click)="
                              !isTitleEditing(product.taskId) &&
                                redirectToTaskSummary(product.taskId)
                            ">
                            <div
                              class="text-muted protitle-text text-truncate col-81 mb-0"
                              *ngIf="!isTitleEditing(product.taskId)"
                              (click)="
                                enableTitleEdit(product);
                                $event.stopPropagation()
                              "
                              pTooltip="{{ product.title }}"
                              tooltipPosition="top"
                              style="cursor: pointer">
                              {{ product.title }}
                            </div>
                            <input
                              *ngIf="isTitleEditing(product.taskId)"
                              pInputText
                              type="text"
                              class="text-muted protitle-text col-81 mb-0"
                              [(ngModel)]="product.title"
                              (keydown.enter)="
                                onTaskFieldEdit(product, 'title')
                              "
                              (keydown.arrowLeft)="$event.stopPropagation()"
                              (keydown.arrowRight)="$event.stopPropagation()"
                              (focus)="onTitleFocus(product)"
                              (focusout)="onTaskFieldEdit(product, 'title')"
                              (pointerdown)="onTitleMouseDown($event)"
                              (pointerup)="onTitleMouseUp($event)"
                              (dblclick)="$event.stopPropagation()"
                              (click)="$event.stopPropagation()" />

                            <div
                              class="text-muted d-flex align-items-center justify-content-between mb-0 duedate-wrapper"
                              (click)="$event.stopPropagation()"
                              style="cursor: pointer">
                              <span class="arrowup">
                                @if (product.isArchived) {
                                  <i
                                    (click)="archiveEvent(product, false)"
                                    class="pi pi-arrow-circle-up weekly-icon"></i>
                                } @else if (!product.isArchived) {
                                  <i
                                    (click)="openDatePicker($event)"
                                    class="pi pi-calendar weekly-icon"></i>
                                }
                              </span>
                              <span
                                class="mt-1 ml-5p"
                                (click)="openDatePicker($event)"
                                >{{
                                  product.dueDate
                                    ? (product.dueDate | date: "MM/dd")
                                    : ""
                                }}</span
                              >
                              <p-datePicker
                                *ngIf="!product.isArchived"
                                #dueDatePickerOverdue
                                class="only-icon"
                                [(ngModel)]="product.calendarDueDate"
                                [showIcon]="true"
                                [iconDisplay]="'input'"
                                appendTo="body"
                                [selectOtherMonths]="true"
                                (onSelect)="
                                  onTaskFieldEdit(product, 'calendarDueDate')
                                "
                                placeholder="Select Date">
                                <ng-template
                                  #inputicon
                                  let-clickCallBack="clickCallBack">
                                  <i
                                    class="pi pi-calendar weekly-icon"
                                    (click)="clickCallBack($event)"></i>
                                </ng-template>
                                <ng-template #footer>
                                  <span
                                    class="link cursor-pointer"
                                    (click)="archiveEvent(product, true)"
                                    >Mark as archived</span
                                  >
                                </ng-template>
                              </p-datePicker>
                            </div>
                          </div>

                          <!-- Status Section -->
                          <div class="mt-2 d-flex gap-2 flex-wrap weekly-badge">
                            <span
                              class="badge badge-overdue p-2 cursor-pointer text-truncate"
                              [class.proof-approved-status]="
                                product.status === 4
                              "
                              #overdueTaskStatus
                              (click)="
                                openStatusPopover(
                                  $event,
                                  product,
                                  overdueTaskStatus
                                )
                              "
                              pTooltip="Click to change status"
                              tooltipPosition="top">
                              @if (product.status !== 0) {
                                {{
                                  product.taskType === 1
                                    ? getTaskStatusTitleSales(product.status)
                                    : getTaskStatusTitleProduction(
                                        product.status
                                      )
                                }}
                              } @else {
                                No Status
                              }
                            </span>
                            <span
                              class="badge d-flex align-items-center gap-1 p-2"
                              *ngFor="let tag of product.tags"
                              [style.backgroundColor]="
                                getTagBackgroundColor(tag.tagColor)
                              "
                              [style.color]="getTagTextColor(tag.tagColor)">
                              <span><i class="pi pi-tag tag-size"></i></span>
                              <span>{{ tag.tagTitle }}</span>
                            </span>
                          </div>

                          <!-- Footer Section -->
                          <div
                            class="mt-2 d-flex align-items-center justify-content-between text-primary fw-semibold small flex-wrap">
                            @if (product.taskType === TaskTypeEnum.Production) {
                              <div
                                class="sub-title fw-normal mb-0 col-lg-4 d-flex justify-content-between align-items-center">
                                <div
                                  (click)="
                                    showOrderSummaryModal(product.salesOrderId)
                                  "
                                  class="cursor-pointer text-truncate"
                                  pTooltip="{{ product.poNumber }}"
                                  tooltipPosition="top"></div>
                                {{ product.poNumber }}

                                <i
                                  class="pi pi-copy cursor-pointer"
                                  (click)="
                                    copyPoNumber(product.poNumber, $event)
                                  "
                                  pTooltip="Copy PO Number"
                                  tooltipPosition="top"></i>
                              </div>
                            } @else if (
                              product.taskType === TaskTypeEnum.Sales
                            ) {
                              <div
                                class="sub-title fw-normal mb-0 col-lg-7 d-flex justify-content-between align-items-center">
                                <div
                                  class="text-truncate"
                                  pTooltip="{{ product.buyerName }}"
                                  tooltipPosition="top">
                                  {{ product.buyerName }}
                                </div>
                              </div>
                            }
                            <!-- <div
                              class="sub-title fw-normal mb-0"
                              *ngIf="product.taskType === TaskTypeEnum.Sales">
                              {{ product.buyerName }}
                            </div> -->
                            @if (product.taskType === TaskTypeEnum.Production) {
                              <div
                                class="sub-title fw-normal mb-0 col-lg-3"
                                [class.border-left-right]="
                                  product.taskType === TaskTypeEnum.Production
                                ">
                                ESD:
                                {{
                                  product.esd ? (product.esd | date: "M/d") : ""
                                }}
                              </div>
                            }
                            <div class="sub-title fw-normal mb-0 col-lg-3">
                              IHD:
                              {{
                                product.ihd ? (product.ihd | date: "M/d") : ""
                              }}
                            </div>

                            <div class="col-auto">
                              <div
                                class="avatar-circle-img"
                                (mouseenter)="
                                  showAvatarPopover(
                                    $event,
                                    product.assignedToUserId
                                  )
                                "
                                (mouseleave)="hideAvatarPopover()">
                                <img
                                  *ngIf="
                                    product.assignedToEmail !== '' &&
                                      getProfilePicture(
                                        product.assignedToEmail
                                      );
                                    else showInitialsWeeklyOverdue
                                  "
                                  [src]="
                                    getProfilePicture(product.assignedToEmail)
                                  "
                                  alt="{{ product.assignedTo }}"
                                  class="profile-picture" />
                                <ng-template #showInitialsWeeklyOverdue>
                                  <span class="fw-bold text-primary">
                                    {{ getInitials(product.assignedTo) }}
                                  </span>
                                </ng-template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Loading indicator for infinite scroll -->
                  <div *ngIf="isLoadingMoreOverdue" class="text-center p-3">
                    <p-skeleton
                      width="100%"
                      height="100px"
                      animation="wave"></p-skeleton>
                  </div>

                  <!-- End of list message -->
                  <div
                    *ngIf="!hasMoreOverdueTasks && overdueTasks.length > 0"
                    class="text-center p-3 text-muted">
                    <small>No more overdue tasks</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- Date-based Swimlanes -->
            <div
              [ngClass]="{
                'col-lg-3 week-col': durationSelected === 'Weekly',
                'col-lg-12': durationSelected === 'Daily',
              }"
              *ngFor="
                let entry of tasksArray.slice(
                  0,
                  durationSelected === 'Weekly'
                    ? visibleDays
                    : tasksArray.length
                )
              "
              pDroppable
              (onDrop)="onDropToSwimlane(entry.date, dropIndex)"
              [class.drop-target-highlight]="
                draggedTask && durationSelected === 'Weekly'
              ">
              <h2 class="mb-3">
                {{ formatHeadDate(entry.date, durationSelected) }}
              </h2>
              <div class="grid-col p-3">
                <div class="card-scroll" #scrollContainer>
                  <div
                    class="ticket-card mb-3 draggable-task"
                    *ngFor="let product of entry.tasks; let i = index"
                    pDraggable
                    [pDraggableDisabled]="isTitleEditing(product.taskId)"
                    pDroppable
                    (onDragStart)="onDragStart(product, entry.date)"
                    (onDragEnd)="onDragEnd()"
                    (onDragEnter)="onDragOver(i)">
                    <!-- <ng-container
                      *ngIf="
                        !product.isExternal || product.isAdmin;
                        else isExternalCard
                      ">
                      <div (click)="redirectToTaskSummary(product.taskId)">
                        <div
                          class="d-flex align-items-center justify-content-between mb-2 gap-1 top-tag">
                          <div
                            class="d-flex align-items-center justify-content-between gap-2">
                            <div
                              class="tag-rounded-box"
                              *ngIf="product.priorityType > 0"
                              [style.background]="
                                getPriorityColor(product.priorityType)
                              "
                              [style.color]="
                                getPriorityTextColor(product.priorityType)
                              ">
                              {{ getPriorityTypeTitle(product.priorityType) }}
                            </div>
                           
                          </div>

                          <span class="card-hd">{{ product.clientName }}</span>

                          <div class="tag-status">
                            {{
                              product.taskType === 1
                                ? getTaskStatusTitleSales(product.status)
                                : getTaskStatusTitleProduction(product.status)
                            }}
                          </div>
                        </div>
                        <div
                          class="d-flex align-items-center justify-content-between mb-2">
                          <div
                            class="col-lg-11 d-flex align-items-center gap-2">
                            <div
                              class="ticket-details col-lg-9 text-truncate"
                              pTooltip="{{ product.title }}"
                              tooltipPosition="top">
                              {{ product.title }}
                              {{
                                getPaddedWorkflowId(product.projectWorkflowId)
                              }}
                            </div>
                          </div>
                          <span
                            class="infoico-circle"
                            *ngIf="product.hasdescription"
                            (click)="redirectToTaskSummary(product.taskId)"
                            ><i class="pi pi-info-circle"></i
                          ></span>
                        </div>

                        <div
                          class="col-lg-12 d-flex gap-2 align-items-center mb-2 mt-2 tag-bar">
                          <div class="hdi-bar">
                            <i class="pi pi-clock"></i>IHD :
                          </div>
                          <div class="hdi-date">
                            {{ product.ihd | date: "MMM d, y" }}
                          </div>
                          <div
                            class="embroided-bar text-truncate"
                            *ngIf="product.jobName.trim() !== ''">
                            <i class="pi pi-shopping-bag"></i
                            >{{ product.jobName }}
                          </div>
                        </div>

                        <div
                          class="d-flex align-items-center justify-content-between">
                          <div class="d-flex gap-2 align-items-center">
                            <div class="green-circle">
                              <div
                                *ngIf="product.assignedTo.trim() !== ''"
                                class="circle-name"
                                [style.color]="getTextColor(product.assignedTo)"
                                [style.background]="
                                  getColor(product.assignedTo)
                                ">
                                {{ product.assignedTo.charAt(0) }}
                              </div>
                            </div>
                            <div class="event-title-tag">
                              <i class="pi pi-circle-fill"></i>
                              {{ getTaskTypeTitle(product.taskType) }}
                            </div>
                          </div>
                          <div
                            class="ticket-chat-link d-flex align-items-center justify-content-between gap-2">
                            <div
                              class="chat-link-text d-flex align-items-center justify-content-between gap-1">
                              <div class="icon">
                                <i class="pi pi-comment"></i>
                              </div>
                              <p class="m-0">{{ product.commentsCount }}</p>
                            </div>
                            <div
                              class="chat-link-text d-flex align-items-center justify-content-between gap-1">
                              <div class="icon"><i class="pi pi-link"></i></div>
                              <p class="m-0">{{ product.attachmentCount }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container> -->
                    <div
                      [ngClass]="{ 'task-gradiant': product.dueDatePassed }"
                      *ngIf="
                        durationSelected === 'Weekly' &&
                        (myTasks ||
                          (!myTasks && !product.isExternal && !product.isAdmin))
                      "
                      (dblclick)="redirectToTaskSummary(product.taskId)">
                      <div
                        class="p-3 custom-card shadow-sm Weekly-card rounded"
                        [style.border-left]="
                          'solid 6px ' +
                          getPriorityColor(
                            product.priorityType,
                            product.taskType
                          )
                        ">
                        <div class="card-body">
                          <!-- Top Section -->
                          <div
                            class="d-flex justify-content-between align-items-start flex-wrap">
                            <div class="col-6">
                              <div
                                class="top-title text-uppercase text-muted text-truncate"
                                pTooltip="{{ product.clientName }}"
                                tooltipPosition="top">
                                {{
                                  product.projectWorkflowId === null &&
                                  product.customerNameWithNoProject
                                    ? product.customerNameWithNoProject
                                    : product.clientName
                                }}
                              </div>

                              <div
                                class="sub-title text-primary text-truncate cursor-pointer"
                                pTooltip="{{ product.jobName }}"
                                tooltipPosition="top"
                                (click)="
                                  openWorkflowSummary({
                                    salesOrderId: product.salesOrderId,
                                    workflowId: product.projectWorkflowId,
                                  });
                                  $event.stopPropagation()
                                ">
                                {{ product.jobName }}
                              </div>
                            </div>

                            <div class="text-start col-auto card-texttrun50">
                              <div
                                class="text-muted border-start ps-2 ms-2 text-truncate"
                                pTooltip="{{ product.nickName }}"
                                tooltipPosition="top"
                                *ngIf="
                                  product.taskType === TaskTypeEnum.Production
                                ">
                                {{ product.nickName }}
                              </div>
                              <div
                                class="text-muted border-start ps-2 ms-2 text-truncate"
                                pTooltip="{{ product.supplierName }}"
                                tooltipPosition="top"
                                *ngIf="
                                  product.taskType === TaskTypeEnum.Production
                                ">
                                {{ product.supplierName }}
                              </div>
                            </div>
                          </div>

                          <!-- Middle Section -->
                          <div
                            class="d-flex justify-content-between align-items-center mt-2 mb-3 flex-wrap"
                            (click)="
                              !isTitleEditing(product.taskId) &&
                                redirectToTaskSummary(product.taskId)
                            ">
                            <div
                              class="text-muted protitle-text text-truncate col-81 mb-0"
                              *ngIf="!isTitleEditing(product.taskId)"
                              (click)="
                                enableTitleEdit(product);
                                $event.stopPropagation()
                              "
                              pTooltip="{{ product.title }}"
                              tooltipPosition="top"
                              style="cursor: pointer">
                              {{ product.title }}
                            </div>
                            <input
                              *ngIf="isTitleEditing(product.taskId)"
                              pInputText
                              type="text"
                              class="text-muted protitle-text col-81 mb-0"
                              [(ngModel)]="product.title"
                              (keydown.enter)="
                                onTaskFieldEdit(product, 'title')
                              "
                              (keydown.arrowLeft)="$event.stopPropagation()"
                              (keydown.arrowRight)="$event.stopPropagation()"
                              (focus)="onTitleFocus(product)"
                              (focusout)="onTaskFieldEdit(product, 'title')"
                              (pointerdown)="onTitleMouseDown($event)"
                              (pointerup)="onTitleMouseUp($event)"
                              (dblclick)="$event.stopPropagation()"
                              (click)="$event.stopPropagation()" />
                            <div
                              class="text-muted d-flex align-items-center justify-content-between mb-0 duedate-wrapper"
                              (click)="$event.stopPropagation()"
                              style="cursor: pointer">
                              <span class="arrowup">
                                @if (product.isArchived) {
                                  <i
                                    (click)="archiveEvent(product, false)"
                                    class="pi pi-arrow-circle-up"></i>
                                } @else if (!product.isArchived) {
                                  <i
                                    (click)="openDatePicker($event)"
                                    class="pi pi-calendar"></i>
                                }
                              </span>
                              <span
                                class="mt-1 ml-5p"
                                (click)="openDatePicker($event)"
                                >{{
                                  product.dueDate
                                    ? (product.dueDate | date: "MM/dd")
                                    : ""
                                }}</span
                              >
                              <p-datePicker
                                #dueDatePickerWeekly
                                class="only-icon"
                                [(ngModel)]="product.calendarDueDate"
                                [showIcon]="true"
                                [iconDisplay]="'input'"
                                appendTo="body"
                                [selectOtherMonths]="true"
                                (onSelect)="
                                  onTaskFieldEdit(product, 'calendarDueDate')
                                "
                                placeholder="Select Date">
                                <ng-template
                                  #inputicon
                                  let-clickCallBack="clickCallBack">
                                  <i
                                    class="pi pi-calendar"
                                    (click)="clickCallBack($event)"></i>
                                </ng-template>
                                <ng-template #footer>
                                  <span
                                    class="link cursor-pointer"
                                    (click)="archiveEvent(product, true)"
                                    >Mark as archived</span
                                  >
                                </ng-template>
                              </p-datePicker>
                            </div>
                          </div>

                          <!-- Status Section -->
                          <div class="mt-2 d-flex gap-2 flex-wrap weekly-badge">
                            <span
                              #weeklyTaskStatus
                              class="badge badge-production p-2 cursor-pointer text-truncate"
                              [class.proof-approved-status]="
                                product.status === 4
                              "
                              (click)="
                                openStatusPopover(
                                  $event,
                                  product,
                                  weeklyTaskStatus
                                )
                              "
                              pTooltip="Click to change status"
                              tooltipPosition="top">
                              @if (product.status !== 0) {
                                {{
                                  product.taskType === 1
                                    ? getTaskStatusTitleSales(product.status)
                                    : getTaskStatusTitleProduction(
                                        product.status
                                      )
                                }}
                              } @else {
                                No Status
                              }
                            </span>
                            <span
                              class="badge d-flex align-items-center gap-1 p-2"
                              *ngFor="let tag of product.tags"
                              [style.backgroundColor]="
                                getTagBackgroundColor(tag.tagColor)
                              "
                              [style.color]="getTagTextColor(tag.tagColor)">
                              <span><i class="pi pi-tag tag-size"></i></span>
                              <span>{{ tag.tagTitle }}</span>
                            </span>
                          </div>

                          <!-- Footer Section -->
                          <div
                            class="mt-2 d-flex align-items-center justify-content-between text-primary fw-semibold small flex-wrap">
                            @if (product.taskType === TaskTypeEnum.Production) {
                              <div
                                class="sub-title fw-normal mb-0 col-lg-4 d-flex justify-content-between align-items-center">
                                <div
                                  (click)="
                                    showOrderSummaryModal(product.salesOrderId)
                                  "
                                  class="cursor-pointer text-truncate"
                                  pTooltip="{{ product.poNumber }}"
                                  tooltipPosition="top">
                                  {{ product.poNumber }}
                                </div>
                                <i
                                  class="pi pi-copy cursor-pointer"
                                  (click)="
                                    copyPoNumber(product.poNumber, $event)
                                  "
                                  pTooltip="Copy PO Number"
                                  tooltipPosition="top"></i>
                              </div>
                            } @else if (
                              product.taskType === TaskTypeEnum.Sales
                            ) {
                              <div
                                class="sub-title fw-normal mb-0 col-lg-7 d-flex justify-content-between align-items-center">
                                <div
                                  class="text-truncate"
                                  pTooltip="{{ product.buyerName }}"
                                  tooltipPosition="top">
                                  {{ product.buyerName }}
                                </div>
                              </div>
                            }
                            <!-- <div
                              class="sub-title fw-normal mb-0"
                              *ngIf="product.taskType === TaskTypeEnum.Sales">
                              {{ product.buyerName }}
                            </div> -->
                            @if (product.taskType === TaskTypeEnum.Production) {
                              <div
                                class="sub-title fw-normal mb-0 col-lg-3"
                                [class.border-left-right]="
                                  product.taskType === TaskTypeEnum.Production
                                ">
                                ESD:
                                {{
                                  product.esd ? (product.esd | date: "M/d") : ""
                                }}
                              </div>
                            }
                            <div class="sub-title fw-normal mb-0 col-lg-3">
                              IHD:
                              {{
                                product.ihd ? (product.ihd | date: "M/d") : ""
                              }}
                            </div>

                            <div class="col-auto">
                              <div
                                class="avatar-circle-img"
                                (mouseenter)="
                                  showAvatarPopover(
                                    $event,
                                    product.assignedToUserId
                                  )
                                "
                                (mouseleave)="hideAvatarPopover()">
                                <img
                                  *ngIf="
                                    product.assignedToEmail !== '' &&
                                      getProfilePicture(
                                        product.assignedToEmail
                                      );
                                    else showInitialsWeekly
                                  "
                                  [src]="
                                    getProfilePicture(product.assignedToEmail)
                                  "
                                  alt="{{ product.assignedTo }}"
                                  class="profile-picture" />
                                <ng-template #showInitialsWeekly>
                                  <span class="fw-bold text-primary">
                                    {{ getInitials(product.assignedTo) }}
                                  </span>
                                </ng-template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12 daily-task-bar"
                      [ngClass]="{ 'task-gradiant': product.dueDatePassed }"
                      *ngIf="
                        durationSelected === 'Daily' &&
                        (myTasks ||
                          (!myTasks && !product.isExternal && !product.isAdmin))
                      "
                      (dblclick)="redirectToTaskSummary(product.taskId)">
                      <div class="task-card-wrapper">
                        <div
                          class="task-card d-flex rounded overflow-hidden shadow-sm">
                          <!-- Left Color Border -->
                          <div
                            class="task-card-border"
                            [style.backgroundColor]="
                              product.dueDatePassed
                                ? '#3a3a3a'
                                : getPriorityColor(
                                    product.priorityType,
                                    product.taskType
                                  )
                            "></div>

                          <!-- Main Content -->
                          <div class="task-content flex-grow-1">
                            <div class="task-row">
                              <!-- Left Section -->
                              <div class="col-wdth01">
                                <div class="min-hgt16">
                                  <h6
                                    class="text-uppercase mb4 text-dark text-truncate"
                                    pTooltip="{{ product.clientName }}"
                                    tooltipPosition="top">
                                    {{
                                      product.projectWorkflowId === null &&
                                      product.customerNameWithNoProject
                                        ? product.customerNameWithNoProject
                                        : product.clientName
                                    }}
                                  </h6>
                                </div>
                                <div class="min-hgt16">
                                  <h6
                                    class="blue-col text-uppercase text-truncate cursor-pointer"
                                    pTooltip=" {{ product.jobName }}"
                                    tooltipPosition="top"
                                    (click)="
                                      openWorkflowSummary({
                                        salesOrderId: product.salesOrderId,
                                        workflowId: product.projectWorkflowId,
                                      });
                                      $event.stopPropagation()
                                    ">
                                    {{ product.jobName }}
                                  </h6>
                                </div>
                              </div>

                              <!-- Middle Left Section -->
                              <div class="col-wdth02 middle-leftsec">
                                <div class="min-hgt16">
                                  <h6
                                    class="mb4 text-uppercase border-left-task pl-2 text-truncate font-wgt600"
                                    pTooltip="{{ product.nickName }}"
                                    tooltipPosition="top"
                                    *ngIf="
                                      product.taskType ===
                                      TaskTypeEnum.Production
                                    ">
                                    {{ product.nickName }}
                                  </h6>
                                </div>
                                <div class="min-hgt16">
                                  <h6
                                    class="mb-0 text-uppercase border-left-task pl-2 text-truncate font-wgt600"
                                    pTooltip="{{ product.supplierName }}"
                                    tooltipPosition="top"
                                    *ngIf="
                                      product.taskType ===
                                      TaskTypeEnum.Production
                                    ">
                                    {{ product.supplierName }}
                                  </h6>
                                </div>
                              </div>

                              <!-- Center Section - FLEXIBLE -->
                              <div class="col-wdth03 center-sec">
                                <div class="min-hgt16">
                                  <p
                                    class="mb-1 text-truncate"
                                    *ngIf="!isTitleEditing(product.taskId)"
                                    (click)="
                                      enableTitleEdit(product, 'daily');
                                      $event.stopPropagation()
                                    "
                                    pTooltip="{{ product.title }}"
                                    tooltipPosition="top"
                                    style="cursor: pointer">
                                    {{ product.title }}
                                  </p>
                                  <input
                                    *ngIf="isTitleEditing(product.taskId)"
                                    pInputText
                                    type="text"
                                    class="mb-2 dailyInput"
                                    [(ngModel)]="product.title"
                                    (keydown.enter)="
                                      onTaskFieldEdit(product, 'title')
                                    "
                                    (keydown.arrowLeft)="
                                      $event.stopPropagation()
                                    "
                                    (keydown.arrowRight)="
                                      $event.stopPropagation()
                                    "
                                    (focus)="onTitleFocus(product)"
                                    (focusout)="
                                      onTaskFieldEdit(product, 'title')
                                    "
                                    (pointerdown)="onTitleMouseDown($event)"
                                    (pointerup)="onTitleMouseUp($event)"
                                    (dblclick)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                                </div>
                                <div class="min-hgt-badge">
                                  <div class="d-flex gap-2 flex-wrap">
                                    <span
                                      *ngFor="let tag of product.tags"
                                      class="badge d-flex align-items-center gap-1"
                                      [style.backgroundColor]="
                                        getTagBackgroundColor(tag.tagColor)
                                      "
                                      [style.color]="
                                        getTagTextColor(tag.tagColor)
                                      ">
                                      <i class="pi pi-tag"></i>
                                      {{ tag.tagTitle }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <!-- Date Section - LOCKED -->
                              <div class="col-wdth04">
                                <div
                                  class="d-flex align-items-center justify-content-center mb-2 gap-1 duedate-wrapper"
                                  (click)="$event.stopPropagation()"
                                  style="cursor: pointer">
                                  <p-datePicker
                                    *ngIf="!product.isArchived"
                                    #dueDatePickerDaily
                                    class="only-icon"
                                    [(ngModel)]="product.calendarDueDate"
                                    [showIcon]="true"
                                    [iconDisplay]="'input'"
                                    appendTo="body"
                                    [selectOtherMonths]="true"
                                    (onSelect)="
                                      onTaskFieldEdit(
                                        product,
                                        'calendarDueDate'
                                      )
                                    "
                                    placeholder="Select Date">
                                    <ng-template
                                      #inputicon
                                      let-clickCallBack="clickCallBack">
                                      <i
                                        class="pi pi-calendar"
                                        (click)="clickCallBack($event)"></i>
                                    </ng-template>
                                    <ng-template #footer>
                                      <span
                                        class="link cursor-pointer"
                                        (click)="archiveEvent(product, true)"
                                        >Mark as archived</span
                                      >
                                    </ng-template>
                                  </p-datePicker>
                                  <span
                                    *ngIf="product.isArchived"
                                    class="arrowup">
                                    <i
                                      (click)="archiveEvent(product, false)"
                                      class="pi pi-arrow-circle-up"></i>
                                  </span>
                                  <p
                                    (click)="openDatePicker($event)"
                                    class="mb-0 mt-1 duedate-text">
                                    {{
                                      product.dueDate
                                        ? (product.dueDate | date: "MM/dd")
                                        : ""
                                    }}
                                  </p>
                                </div>
                                <span
                                  #dailyTaskStatus
                                  [class.proof-approved-status]="
                                    product.status === 4
                                  "
                                  [class.status-badge]="!product.dueDatePassed"
                                  [class.status-badge-overdue]="
                                    product.dueDatePassed
                                  "
                                  class="text-white justify-content-center rounded cursor-pointer text-truncate"
                                  (click)="
                                    openStatusPopover(
                                      $event,
                                      product,
                                      dailyTaskStatus
                                    )
                                  "
                                  pTooltip="Click to change status"
                                  tooltipPosition="top">
                                  @if (product.status !== 0) {
                                    {{
                                      product.taskType === 1
                                        ? getTaskStatusTitleSales(
                                            product.status
                                          )
                                        : getTaskStatusTitleProduction(
                                            product.status
                                          )
                                    }}
                                  } @else {
                                    No Status
                                  }
                                </span>
                              </div>

                              <!-- PO/ESD/Buyer Section - LOCKED (Production) -->
                              <div class="col-wdth05">
                                <div class="details-grid">
                                  <div class="details-left">
                                    <span class="min-h20">
                                      <p
                                        class="blue-col m-0 text-start po-number">
                                        @if (
                                          product.taskType ===
                                          TaskTypeEnum.Production
                                        ) {
                                          <span
                                            (click)="
                                              showOrderSummaryModal(
                                                product.salesOrderId
                                              )
                                            "
                                            class="cursor-pointer"
                                            >{{ product.poNumber }}</span
                                          >
                                        }
                                      </p>
                                    </span>
                                    <p
                                      class="mb-0 blue-col text-start esd-text mt-2">
                                      @if (
                                        product.taskType ===
                                        TaskTypeEnum.Production
                                      ) {
                                        ESD:
                                        {{
                                          product.esd
                                            ? (product.esd | date: "M/d")
                                            : ""
                                        }}
                                      }
                                    </p>
                                  </div>
                                  <div class="details-divider">
                                    <span class="min-h20">
                                      <span
                                        class="copy-icon cursor-pointer"
                                        (click)="
                                          copyPoNumber(product.poNumber, $event)
                                        "
                                        pTooltip="Copy PO Number"
                                        tooltipPosition="top">
                                        @if (
                                          product.taskType ===
                                          TaskTypeEnum.Production
                                        ) {
                                          <i class="pi pi-copy blue-col"></i>
                                        }
                                      </span>
                                    </span>
                                    <span class="separator mt-2">
                                      @if (
                                        product.taskType ===
                                        TaskTypeEnum.Production
                                      ) {
                                        |
                                      }
                                    </span>
                                  </div>
                                  <div class="details-right">
                                    <span class="min-h20">
                                      <p
                                        class="blue-col fw-semibold m-0 text-truncate text-uppercase buyer-name"
                                        pTooltip="{{ product.buyerName }}"
                                        tooltipPosition="top">
                                        {{ product.buyerName }}
                                      </p>
                                    </span>
                                    <p class="mb-0 mt-2 blue-col ihd-text">
                                      IHD:
                                      {{
                                        product.ihd
                                          ? (product.ihd | date: "M/d")
                                          : ""
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <!-- Buyer Section - LOCKED (Sales) -->
                              <!-- <div
                                class="col-wdth05"
                                *ngIf="
                                  product.taskType !== TaskTypeEnum.Production
                                ">
                                <div class="details-grid sales-task">
                                  <div class="details-right">
                                    <p
                                      class="blue-col fw-semibold m-0 text-truncate text-uppercase buyer-name">
                                      {{ product.buyerName }}
                                    </p>
                                    <p class="mb-0 blue-col ihd-text">
                                      IHD:
                                      {{
                                        product.ihd
                                          ? (product.ihd | date: "M/d")
                                          : ""
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div> -->

                              <!-- Avatar - LOCKED -->
                              <div class="col-wdth06">
                                <div
                                  class="rounder-tast-name rounded-circle"
                                  (mouseenter)="
                                    showAvatarPopover(
                                      $event,
                                      product.assignedToUserId
                                    )
                                  "
                                  (mouseleave)="hideAvatarPopover()">
                                  <img
                                    *ngIf="
                                      product.assignedToEmail !== '' &&
                                        getProfilePicture(
                                          product.assignedToEmail
                                        );
                                      else showInitials
                                    "
                                    [src]="
                                      getProfilePicture(product.assignedToEmail)
                                    "
                                    alt="{{ product.assignedTo }}"
                                    class="profile-picture" />
                                  <ng-template #showInitials>
                                    <span class="fw-bold blue-col">
                                      {{ getInitials(product.assignedTo) }}
                                    </span>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #isExternalCard>
                      <div
                        class="d-flex align-items-center justify-content-between mb-2">
                        <div class="col-lg-11 d-flex align-items-center gap-1">
                          <div class="ticket-details col-lg-9 text-truncate">
                            {{ product.title }}
                            {{ getPaddedWorkflowId(product.projectWorkflowId) }}
                          </div>
                        </div>
                      </div>
                      <p-skeleton
                        width="100%"
                        class="board-loader02"
                        animation="none"></p-skeleton>
                      <p-skeleton
                        width="60%"
                        class="board-loader02"
                        animation="none"></p-skeleton>
                      <p-skeleton
                        width="100%"
                        class="board-loader03"
                        animation="none"></p-skeleton>

                      <div class="n-circle">
                        <div
                          *ngIf="product.assignedTo.trim() !== ''"
                          class="circle-name"
                          [style.color]="getTextColor(product.assignedTo)"
                          [style.background]="getColor(product.assignedTo)"
                          (mouseenter)="
                            showAvatarPopover($event, product.assignedToUserId)
                          "
                          (mouseleave)="hideAvatarPopover()">
                          {{ product.assignedTo.charAt(0) }}
                        </div>
                      </div>
                    </ng-template>
                  </div>

                  <!-- Task Card 1 -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #monthlyView>
    <div
      #calendarContainer
      [ngClass]="{ small: small, medium: medium, large: large }"
      class="col-lg-12 month-board">
      <full-calendar
        #fullCalendar
        [options]="calendarOptions"
        [events]="eventsPromise | async">
        <ng-template #eventContent let-arg>
          <ng-container
            *ngIf="arg.event.extendedProps.isInternal; else externalTaskDec">
            <div class="cal-box" (click)="redirectToTaskSummary(arg.event.id)">
              <div class="d-flex justify-content-between align-items-center">
                <div class="event-title">{{ arg.event.title }}</div>
                <span class="infoico-circle"
                  ><i class="pi pi-info-circle"></i
                ></span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <div
                  class="event-title-user"
                  *ngIf="arg.event.extendedProps.assignedTo.trim() !== ''"
                  [style.color]="
                    getTextColor(arg.event.extendedProps.assignedTo)
                  "
                  [style.background]="
                    getColor(arg.event.extendedProps.assignedTo)
                  "
                  (mouseenter)="
                    showAvatarPopover(
                      $event,
                      arg.event.extendedProps.assignedToUserId
                    )
                  "
                  (mouseleave)="hideAvatarPopover()">
                  {{ arg.event.extendedProps.assignedTo.charAt(0) }}
                </div>
                <div class="event-title-tag">
                  <i class="pi pi-circle-fill"></i>
                  {{ getTaskTypeTitle(arg.event.extendedProps.taskType) }}
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #externalTaskDec>
            <div class="cal-box">
              <div class="event-title">
                <p-skeleton
                  width="100%"
                  class="board-loader02"
                  animation="none"></p-skeleton>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <div
                  class="event-title-user"
                  *ngIf="arg.event.extendedProps.assignedTo.trim() !== ''"
                  [style.color]="
                    getTextColor(arg.event.extendedProps.assignedTo)
                  "
                  [style.background]="
                    getColor(arg.event.extendedProps.assignedTo)
                  "
                  (mouseenter)="
                    showAvatarPopover(
                      $event,
                      arg.event.extendedProps.assignedToUserId
                    )
                  "
                  (mouseleave)="hideAvatarPopover()">
                  {{ arg.event.extendedProps.assignedTo.charAt(0) }}
                </div>
              </div>
            </div>
          </ng-template>
        </ng-template>
      </full-calendar>
    </div>
  </ng-template>

  <!-- <p-dialog
    [(visible)]="displayTaskDetailModal"
    (onHide)="closeTaskDetailModal()"
    class="summary-popup"
    [style]="{ width: '60%', height: '80%', maxHeight: '100%' }"
    appendTo="body">
    <jni-task-summary
      *ngIf="displayTaskDetailModal"
      #childComp
      [showTaskHeader]="showEditTaskModal"
      (closeAddTask)="closeTaskDetailModal()"
      [taskIdSelected]="taskIdSelected"></jni-task-summary>
  </p-dialog> -->

  <!-- <jni-task-summary
    *ngIf="displayTaskDetailModal"
    [displayTaskDetailModal]="displayTaskDetailModal"
    [showTaskHeader]="showEditTaskModal"
    (closeAddTask)="closeTaskDetailModal()"
    (closeTaskDetailModalEvent)="closeTaskDetailModal()"
    [taskIdSelected]="taskIdSelected">
  </jni-task-summary> -->

  <jni-task-header-edit
    #taskHeaderEdit
    *ngIf="displayTaskDetailModal"
    [displayModal]="displayTaskDetailModal"
    [showTaskHeader]="showEditTaskModal"
    (closeAddTask)="closeTaskDetailModal($event)"
    [taskIdSelected]="taskIdSelected"
    (showContact)="showContactDialog($event)"
    [actionType]="'Edit'">
  </jni-task-header-edit>
</div>

<p-popover #statusOverlay appendTo="body" styleClass="status-dropdown-popover">
  <ng-template #content>
    <div class="status-dropdown-menu" *ngIf="currentProductForStatus">
      <ng-container
        *ngIf="
          currentProductForStatus.taskType === 2;
          else salesStatusTemplate
        ">
        <div
          *ngFor="let status of prodStatusDropDownList"
          class="status-option"
          [ngClass]="{
            disabled: status.value === currentProductForStatus.status,
            active: status.value === currentProductForStatus.status,
          }"
          (click)="
            status.value !== currentProductForStatus.status &&
              onStatusDropDownChange(
                currentProductForStatus.taskId,
                status.value,
                currentProductForStatus.taskType
              );
            status.value !== currentProductForStatus.status &&
              statusOverlay.hide()
          ">
          <span class="d-flex align-items-center gap-2">
            <i
              class="pi pi-check"
              *ngIf="status.value === currentProductForStatus.status"></i>
            <span>{{ status.label }}</span>
          </span>
        </div>
      </ng-container>
      <ng-template #salesStatusTemplate>
        <div
          *ngFor="let status of statusList"
          class="status-option"
          [ngClass]="{
            disabled: status.value === currentProductForStatus.status,
            active: status.value === currentProductForStatus.status,
          }"
          (click)="
            status.value !== currentProductForStatus.status &&
              onStatusDropDownChange(
                currentProductForStatus.taskId,
                status.value,
                currentProductForStatus.taskType
              );
            status.value !== currentProductForStatus.status &&
              statusOverlay.hide()
          ">
          <span class="d-flex align-items-center gap-2">
            <i
              class="pi pi-check"
              *ngIf="status.value === currentProductForStatus.status"></i>
            <span>{{ status.label }}</span>
          </span>
        </div>
      </ng-template>
    </div>
  </ng-template>
</p-popover>

<p-popover
  #avatarUserPopover
  appendTo="body"
  (onShow)="keepPopoverOpen()"
  (onHide)="onAvatarLeave()"
  styleClass="avatar-popover-card">
  <ng-template #content>
    <jni-user-avatar-details
      #userAvatarDetailsComp
      *ngIf="showUserAvatarDetails"
      [userAvatorDetails]="userAvatorDetails"
      [isLoading]="isLoading"
      (mouseenter)="keepPopoverOpen()"
      (mouseleave)="hideAvatarPopover()">
    </jni-user-avatar-details>
  </ng-template>
</p-popover>

<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle">
</p-confirmDialog>

<jni-confirm-dialog
  [dialogMessage]="archiveMessage"
  dialogHeading="Are you sure?"
  *ngIf="archiveAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmArchive($event)">
</jni-confirm-dialog>
